module.exports = __webpack_public_path__ + "media/images/icons/magnifying-glass-c9ad79115929f073d45d5e66407552fa.svg";